export const PROJECT_PICKER_ELEMENT_ID =
	'issue-create.ui.modal.create-form.project-picker.project-select';
